import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground",
        critical: "bg-red-600/20 text-red-400 border-red-600/30",
        high: "bg-orange-600/20 text-orange-400 border-orange-600/30",
        medium: "bg-yellow-600/20 text-yellow-400 border-yellow-600/30",
        low: "bg-green-600/20 text-green-400 border-green-600/30",
        info: "bg-cyan-600/20 text-cyan-400 border-cyan-600/30",
        pending: "bg-indigo-600/20 text-indigo-400 border-indigo-600/30",
        confirmed: "bg-red-600/20 text-red-400 border-red-600/30",
        "false-positive": "bg-green-600/20 text-green-400 border-green-600/30",
        mitigated: "bg-cyan-600/20 text-cyan-400 border-cyan-600/30",
        deferred: "bg-purple-600/20 text-purple-400 border-purple-600/30",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
